import type { EffectPlaybackAudience } from "../../models/contracts";

export const SHORT_EFFECT_REPEAT_THRESHOLD_MS = 15_000;

export const shouldPersistEffect = (audience: EffectPlaybackAudience): boolean =>
  audience === "Crowd";

export const shouldAutoRepeatEffect = (durationMs: number): boolean =>
  durationMs > 0 && durationMs < SHORT_EFFECT_REPEAT_THRESHOLD_MS;

export const getEffectPlaybackDurationMs = (durationMs: number): number =>
  shouldAutoRepeatEffect(durationMs) ? durationMs * 2 : durationMs;
